import karteCustonEventClient from '../common/karte/custom_event';

document.addEventListener('DOMContentLoaded', () => {
  const bulkEditDiv = document.getElementById('feature_authority_staff_accounts_bulk_edit') as HTMLElement;
  if (bulkEditDiv == null) {
    return;
  }
  const checkAllButton = document.querySelector('.all-check') as HTMLElement;
  const clearAllButton = document.querySelector('.all-clear') as HTMLElement;
  const checkboxes = document.querySelectorAll('.staff-id-checkbox');

  checkAllButton.addEventListener('click', () => {
    checkAll();
  });

  clearAllButton.addEventListener('click', () => {
    checkboxes.forEach(checkbox => {
      (checkbox as HTMLInputElement).checked = false;
    });
  });

  const checkAll = () => {
    checkboxes.forEach(checkbox => {
      (checkbox as HTMLInputElement).checked = true;
    });
  }

  const sendKarteEvent = (event_name: string, content_name: string, message: string) => {
    // 更新したことをKARTEに通知
    karteCustonEventClient.sendEvent({
      event_name: event_name,
      content_name: content_name,
      message: message
    });
  }

  // 更新時に実行
  bulkEditDiv.addEventListener('submit', () => {
    // KARTEに登録イベントを送信
    sendKarteEvent(
      'update_content',
      'feature_authority_staff_accounts',
      'スタッフ権限設定のスタッフ割り当てを更新しました'
    );
  })
});
